var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoiceActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MC/Paid"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000009527"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 10.6393V6C21 4.34315 19.6568 3 18 3H9.59998C7.94312 3 6.59998 4.34315 6.59998 6V16.5H16.5V18.75C16.5 19.9926 17.5074 21 18.75 21C19.9926 21 21 19.9926 21 18.75V10.65C21 10.6464 21 10.6429 21 10.6393Z",
    fill: "#383434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 10.6393H20.5L20.5 10.6416L21 10.6393ZM6.59998 16.5H6.09998C6.09998 16.7761 6.32383 17 6.59998 17V16.5ZM16.5 16.5H17C17 16.2239 16.7761 16 16.5 16V16.5ZM20.5 6V10.6393H21.5V6H20.5ZM18 3.5C19.3807 3.5 20.5 4.61929 20.5 6H21.5C21.5 4.067 19.933 2.5 18 2.5V3.5ZM9.59998 3.5H18V2.5H9.59998V3.5ZM7.09998 6C7.09998 4.61929 8.21926 3.5 9.59998 3.5V2.5C7.66698 2.5 6.09998 4.067 6.09998 6H7.09998ZM7.09998 16.5V6H6.09998V16.5H7.09998ZM16.5 16H6.59998V17H16.5V16ZM16 16.5V18.75H17V16.5H16ZM16 18.75C16 20.2688 17.2312 21.5 18.75 21.5V20.5C17.7835 20.5 17 19.7165 17 18.75H16ZM18.75 21.5C20.2688 21.5 21.5 20.2688 21.5 18.75H20.5C20.5 19.7165 19.7165 20.5 18.75 20.5V21.5ZM21.5 18.75V10.65H20.5V18.75H21.5ZM21.5 10.65C21.5 10.6456 21.5 10.6413 21.5 10.637L20.5 10.6416C20.5 10.6444 20.5 10.6472 20.5 10.65H21.5Z",
    fill: "#383434"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3 18V16.5H15.6C16.0971 16.5 16.5 16.9029 16.5 17.4V18.904C16.5 19.1006 16.519 19.2982 16.5929 19.4803C16.8487 20.1106 17.5103 21 18.75 21H6C4.34315 21 3 19.6569 3 18Z",
    fill: "#383434",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.75 21C17.5103 21 16.8487 20.1106 16.5929 19.4803C16.519 19.2982 16.5 19.1006 16.5 18.904V17.4C16.5 16.9029 16.0971 16.5 15.6 16.5V16.5H3",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.9541 10.7065H17.1675",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.9541 6.58852H17.1675",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceActive);
export default __webpack_public_path__ + "static/media/invoiceActive.62361498a2b083d8e6d27a90bb3599de.svg";
export { ForwardRef as ReactComponent };